import EntityServise from "./entityService.js";
import regTypeService from "./regTypeService";
import regService from "./regService";
import reportService from "./reportService";
import resourceService from "./resourceService";
import http from "../util/ws/wsService.js";

class PrinterService extends EntityServise {
  constructor() {
    super("printer");
  }
  routePrintTexts = "/print/text";
  async sendPrintTextsByRegTypeIdAndRegId(regId) {
    let regRes = await regService.regById(regId);
    if (!regRes.success) return regRes;
    
    const reg = regRes?.data;
    let regTypeRes = await regTypeService.getById(regRes.data.regTypeId);
    if (!regTypeRes.success) return regTypeRes;

    const resourceRes = await resourceService.getById(reg.resourceId);
    if (!resourceRes.success) return resourceRes;

    const resource = resourceRes.data;

    let resourcePrinter = null;

    if (resource.printerId) {
      const printerRes = await this.getById(resource.printerId);
      if (resourceRes.success)
        resourcePrinter = printerRes.data;
    }

    if (regTypeRes.data.reportId) {
      let printRes = await reportService.getByRegId(regId);
      if (!printRes.success) return printRes;

      const printerPath = resourcePrinter
        ? resourcePrinter.path
        : printRes.data.printerPath;
      const printAgentPath = resourcePrinter
        ? resourcePrinter.printAgentPath
        : printRes.data.printAgentPath;

      if (printRes.success) {
        let resPrintTexts = await this.sendPrintTexts(
          printRes.data.prints,
          printerPath,
          printAgentPath
        );

        if (resPrintTexts.data.success) {
          return resPrintTexts;
        }
        return { success: true, data: ["Success"] };
        
      } else {
        return { success: false, data: ["Report not found"] };
      }
    } else {
      return { success: false, data: ["Report not found"] };
    }
  }

  async sendPrintTexts(text, printerPath, printAgentPath) {
    console.log(text)
    var res = { success: true, data: [] };
    // for (let index = 0; index < texts.length; index++) {
    //   const text = texts[index];
      
      try {
        let resRequest = await http.post(
          printAgentPath + this.routePrintTexts,
          { text, printerPath }
        );

        console.log("printerRequest", resRequest);
        if (!resRequest.success) {
          res.success = false;
          resRequest.data.forEach((err) => res.data.push(err));
          return res;
        }
      } catch (err) {
        return { success: false, data: ["Try print error: " + err.message] };
      }
    // }

    return res;
  }
}

export default new PrinterService();
